import React from "react";
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/SideBar";
import Pos from "../pages/Pos";

function PosLayout(){
    return (
    <>
     <Pos />
    </>

    );
}

export default PosLayout;